import { useController, type Control, type FieldPath, type FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Select, type SelectOption } from '@/components/ui/Select'

export interface FormSelectProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>
  name: FieldPath<TFieldValues>
  label?: string
  description?: string
  placeholder?: string
  options: SelectOption[]
  isDisabled?: boolean
  isRequired?: boolean
  className?: string
}

export function FormSelect<TFieldValues extends FieldValues>({
  control,
  name,
  options,
  ...props
}: FormSelectProps<TFieldValues>) {
  const { t } = useTranslation()
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name,
  })

  return (
    <Select
      {...props}
      options={options}
      selectedKey={field.value}
      onSelectionChange={(key) => field.onChange(key)}
      errorMessage={error?.message ? t(error.message) : undefined}
      isInvalid={!!error}
    />
  )
}

export default FormSelect
